export default "__VITE_ASSET__BgtoFR1t__"